// How It Works - Investment Process Guide

export const howItWorks = {
  hero: {
    title: "Start Investing With Us",
    subtitle: "Your journey to investing in Israeli innovation starts here",
    description: "Join 20,000+ investors accessing the best Israeli tech startups"
  },

  steps: [
    {
      number: 1,
      title: "Create Your Account",
      description: "Sign up for free and complete your investor profile. The process takes just 5 minutes.",
      details: [
        "Provide basic information",
        "Complete accreditation verification",
        "Set your investment preferences",
        "No commitment required"
      ],
      icon: "👤",
      duration: "5 minutes"
    },
    {
      number: 2,
      title: "Choose Your Path",
      description: "Select the investment vehicle that matches your goals and experience level.",
      details: [
        "Angels67 Capital - Self-directed investing",
        "Angels67 Ventures - Managed portfolios",
        "Angels67 Digital Assets - Blockchain focus",
        "Mix and match across all three"
      ],
      icon: "🎯",
      duration: "10 minutes"
    },
    {
      number: 3,
      title: "Browse Opportunities",
      description: "Explore curated Israeli tech startups with full due diligence materials.",
      details: [
        "Comprehensive pitch decks",
        "Financial models and projections",
        "Market analysis and competitive landscape",
        "Team backgrounds and cap tables"
      ],
      icon: "🔍",
      duration: "Ongoing"
    },
    {
      number: 4,
      title: "Make Your Investment",
      description: "Invest in the startups that align with your interests and portfolio strategy.",
      details: [
        "Review investment terms",
        "Set your investment amount",
        "Complete secure payment",
        "Receive confirmation and documentation"
      ],
      icon: "💰",
      duration: "15 minutes per deal"
    },
    {
      number: 5,
      title: "Track & Manage",
      description: "Monitor your portfolio performance and receive regular updates from companies.",
      details: [
        "Real-time portfolio dashboard",
        "Quarterly company updates",
        "Performance metrics and analytics",
        "Exit notifications and proceeds distribution"
      ],
      icon: "📊",
      duration: "Ongoing"
    }
  ],

  paths: [
    {
      name: "Angels67 Capital",
      bestFor: "Experienced investors who want full control",
      minInvestment: "$1,000",
      features: [
        "Self-directed investment decisions",
        "Access to all due diligence",
        "Choose individual deals",
        "Transparent fee structure",
        "Portfolio management tools"
      ],
      cta: "Start Investing"
    },
    {
      name: "Angels67 Ventures",
      bestFor: "Investors seeking professional management",
      minInvestment: "$50,000",
      features: [
        "Professionally managed portfolio",
        "Tailored to your preferences",
        "Diversified across 10-15 companies",
        "Expert deal selection",
        "Quarterly strategy reviews"
      ],
      cta: "Build My Fund"
    },
    {
      name: "Angels67 Digital Assets",
      bestFor: "Blockchain and crypto enthusiasts",
      minInvestment: "$100,000",
      features: [
        "Actively managed fund",
        "Blockchain technology focus",
        "Web3 and crypto opportunities",
        "Professional fund management",
        "Quarterly reporting"
      ],
      cta: "Join The Fund"
    }
  ],

  timeline: {
    title: "What to Expect",
    phases: [
      {
        phase: "First 30 Days",
        activities: [
          "Complete account setup and verification",
          "Attend investor orientation webinar",
          "Review available opportunities",
          "Make your first investment"
        ]
      },
      {
        phase: "First 6 Months",
        activities: [
          "Build a diversified portfolio",
          "Receive company updates",
          "Join investor community events",
          "Access educational resources"
        ]
      },
      {
        phase: "Year 1+",
        activities: [
          "Track portfolio performance",
          "Participate in follow-on rounds",
          "Receive first exit proceeds",
          "Expand your portfolio"
        ]
      }
    ]
  },

  support: {
    title: "We're Here to Help",
    description: "Our team supports you throughout your investment journey",
    services: [
      {
        name: "Dedicated Support Team",
        description: "Get answers to your questions via email, phone, or chat"
      },
      {
        name: "Educational Resources",
        description: "Access webinars, guides, and research reports"
      },
      {
        name: "Investor Community",
        description: "Connect with other investors at exclusive events"
      },
      {
        name: "Expert Guidance",
        description: "Consult with our investment team on strategy"
      }
    ]
  },

  faqs: [
    {
      question: "How much should I invest?",
      answer: "We recommend starting with amounts you're comfortable losing, as venture investments are high-risk. Many investors begin with $5,000-$25,000 and build their portfolio over time."
    },
    {
      question: "How long until returns?",
      answer: "Venture capital is a long-term investment, typically 5-10 years. Some exits happen sooner, others take longer. Diversification helps manage this timeline risk."
    },
    {
      question: "Can I invest through a retirement account?",
      answer: "Yes, we support investments through self-directed IRAs and other qualified retirement accounts. Contact us for details."
    }
  ]
};

export default howItWorks;
